<template>
  <div class="animated fadeIn call_statistics">
    <filters :scope="filtersScope" class="filter-call_statistics">
    </filters>
    <StatisticTable :headColumns="headColumns"
                    :footColumns="footColumns"
                    :rows="rows"
                    :title="title">
    </StatisticTable>
  </div>
</template>

<script>
import Filters from '../../../components/Filters.vue'
import StatisticTable from '../../../components/StatisticTable.vue'
import API from '../../../api/API'
import {map} from 'lodash'
import Helper from '../../../api/Helper'

export default {
  components: {
    Filters,
    StatisticTable
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true,
        WorkShifts: true
      },
      title: 'Статистика по звонкам',
      headColumns: [
        {label: this.$root.$t('statistic.date'), field: 'date', width: '120px'},
        {label: this.$root.$t('statistic.total'), field: 'total'},
        {label: this.$root.$t('statistic.processed'), field: 'processed'},
        {label: this.$root.$t('statistic.accepted'), field: 'accepted'},
        {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
        {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},

        {label: this.$root.$t('statistic.dialer'), field: 'dialer'},
        {label: this.$root.$t('statistic.average_first_call_time'), field: 'average_first_call_time', width: '200px'},
        {label: this.$root.$t('statistic.average_number_touches'), field: 'average_number_touches', width: '200px'},
        {label: this.$root.$t('statistic.average_calls'), field: 'average_calls', width: '200px'},
        {label: this.$root.$t('statistic.active_operators'), field: 'active_operators', width: '180px'},
        {label: this.$root.$t('statistic.approve'), field: 'approve'},
        {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'}
      ],
      rows: [],
      footColumns: {},
      isWork: null
    }
  },
  mounted () {
    this.$root.$on('handleChangeClose', (isWorkShift) => {
      this.isWork = isWorkShift
      this.calculateRows(this.isWork)
    })
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    hourAndMin (data) {
      let hourse = Math.floor(data / 60 / 60)
      let minutes = Math.floor(data / 60) - (hourse * 60)
      let seconds = Math.floor(data % 60)
      return `${hourse} ч. ${minutes} м. ${seconds} с.`
    },
    calculateRows () {
      this.rows = []
      this.footColumns = {}
      this.title = 'Статистика по звонкам'
      API.getCallStatistics(this.isWork).then(response => {
        let sumTotal = 0
        let sumProcessed = 0
        let countProcessed = 0
        let sumAccepted = 0
        let countAccepted = 0
        let sumCanceled = 0
        let countCanceled = 0
        let sumError = 0
        let countError = 0
        let sumDialer = 0.0
        let sumAverageFirstCallTime = 0.0
        let sumAverageFirstCallTimeCount = 0
        let sumAverageChanges = 0.0
        let sumAverageChangesCount = 0
        let sumVverageCalls = 0.0
        let sumVverageCallsCount = 0
        let countDialer = 0.0
        let arrActiveOperators = []
        let totalOperatorsActive = 0
        const count = Object.keys(response.data).length
        map(response.data, (data) => {
          let arr = data.active_operators
          arrActiveOperators.push(arr)
        })
        let splitArr = arrActiveOperators.map(item => {
          return item.split(',')
        })
        let concatArrOperatorsActive = []
        for (let i = 0; i < splitArr.length; i++) {
          concatArrOperatorsActive.push(...splitArr[i])
        }
        let filterArr = concatArrOperatorsActive.filter((item, index) => {
          return concatArrOperatorsActive.indexOf(item) === index
        })
        totalOperatorsActive = filterArr.length
        map(response.data, (data) => {
          this.rows.push({
            date: {
              value: data.date
            },
            total: {
              value: data.total
            },
            processed: {
              value: data.processed
            },
            accepted: {
              value: data.approved
            },
            canceled: {
              value: data.canceled
            },
            canceledPercents: {
              value: Helper.percents(data.total, data.canceled),
              bgg: Helper.renderGistPart(data.total, data.canceled, true)
            },
            error: {
              value: data.error
            },
            errorPercents: {
              value: Helper.percents(data.total, data.error),
              bgg: Helper.renderGistPart(data.total, data.error, true)
            },
            dialer: {
              value: data.ring_up_percent + ' %'
            },
            average_first_call_time: {
              value: `${this.hourAndMin(data.average_first_call_time)}`
            },
            average_number_touches: {
              value: data.average_changes.toString().replace('.', ',')
            },
            average_calls: {
              value: data.average_calls.toString().replace('.', ',')
            },
            active_operators: {
              value: data.active_operators.split(',').length
            },
            approve: {
              value: Helper.percents(data.total, data.approved),
              bgg: Helper.renderSingleGist(data.total, data.approved)
            },
            approvedFromValid: {
              value: Helper.approvedFromValid(data.approved, data.total, data.error)
            }
          })
          if (data.total > 0) {
            sumTotal += parseInt(data.total)
          }
          if (data.processed > 0) {
            sumProcessed += parseInt(data.processed)
            countProcessed++
          }
          if (data.approved > 0) {
            sumAccepted += parseInt(data.approved)
            countAccepted++
          }
          if (data.canceled > 0) {
            sumCanceled += parseInt(data.canceled)
            countCanceled++
          }
          if (data.error > 0) {
            sumError += parseInt(data.error)
            countError++
          }
          if (data.ring_up_percent > 0) {
            sumDialer += data.ring_up_percent
            countDialer++
          }
          if (data.average_first_call_time > 0) {
            sumAverageFirstCallTime += data.average_first_call_time
            sumAverageFirstCallTimeCount++
          }
          if (data.average_changes > 0) {
            sumAverageChanges += data.average_changes
            sumAverageChangesCount++
          }
          if (data.average_calls) {
            sumVverageCalls += data.average_calls
            sumVverageCallsCount++
          }
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: `${sumTotal}`,
              graph: true
            },
            processed: {
              value: `${sumProcessed}`,
              graph: true
            },
            accepted: {
              value: `${sumAccepted}`,
              graph: true
            },
            canceled: {
              value: `${sumCanceled}`,
              graph: true
            },
            canceledPercents: {
              value: Helper.percents(sumTotal, sumCanceled),
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '%'
              }
            },
            error: {
              value: `${sumError}`,
              graph: true
            },
            errorPercents: {
              value: Helper.percents(sumTotal, sumError),
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '%'
              }
            },
            dialer: {
              value: Helper.averageFloat(sumDialer, countDialer) + ' %',
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '%'
              }
            },
            average_first_call_time: {
              value: this.hourAndMin(Helper.averageFloat(sumAverageFirstCallTime, sumAverageFirstCallTimeCount))
            },
            average_number_touches: {
              value: sumAverageChanges ? Helper.averageFloat(sumAverageChanges, sumAverageChangesCount).replace('.', ',') : '0,0'
            },
            average_calls: {
              value: sumVverageCalls ? Helper.averageFloat(sumVverageCalls, sumVverageCallsCount).replace('.', ',') : '0,0'
            },
            active_operators: {
              value: totalOperatorsActive
            },
            approve: {
              value: Helper.percents(sumTotal, sumAccepted),
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '%'
              }
            },
            approvedFromValid: {
              value: Helper.approvedFromValid(sumAccepted, sumTotal, sumError)
            }
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CallStatistics.vue?27cb350c